import moment from 'moment'
import { NewsItem, publishedTime } from '@/modules/shared/query-client/useQueryNews'

type Appearance = {
  labelKey: string
  labelFallback: string
  pillClassName: string
}

const APPEARANCE: Record<string, Appearance> = {
  feature: {
    labelKey: 'news.type-feature',
    labelFallback: 'Nowość',
    pillClassName: 'tw-bg-primary/10 tw-text-primary',
  },
  improvement: {
    labelKey: 'news.type-improvement',
    labelFallback: 'Ulepszenie',
    pillClassName: 'tw-bg-accent/15 tw-text-accent',
  },
  change: {
    labelKey: 'news.type-change',
    labelFallback: 'Zmiana',
    pillClassName: 'tw-bg-warning/15 tw-text-warning',
  },
  fix: {
    labelKey: 'news.type-fix',
    labelFallback: 'Poprawka',
    pillClassName: 'tw-bg-success/15 tw-text-success',
  },
}

const FALLBACK: Appearance = {
  labelKey: 'news.type-other',
  labelFallback: 'Aktualizacja',
  pillClassName: 'tw-bg-base-300 tw-text-content-base',
}

export const newsAppearance = (type: string | null | undefined): Appearance =>
  (type && APPEARANCE[type.toLowerCase()]) || FALLBACK

export const formatNewsDate = (item: NewsItem) => {
  const time = publishedTime(item)
  return time ? moment(time).format('DD-MM-YYYY') : ''
}
